module.exports = __webpack_public_path__ + "img/2.918a7a98.jpg";